import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import headerOne from "../../assets/images/header_five.jpg";
import headerTwo from "../../assets/images/header_four.jpg";
import headerThree from "../../assets/images/header_three.jpg";
import { HeaderContent } from "./HeaderStyle";
import { Button } from "../../AppStyle";

const Header = () => {
  return (
    <>
      <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        interval={6000}
        infiniteLoop={true}
        autoPlay={true}
        dynamicHeight={false}
      >
        <div id="home">
          <img src={headerOne} alt="Header One" />
          <HeaderContent className="responsive-header">
            <h1 style={{ marginTop: 0, marginBottom: 0 }}>
              LET US HELP BUILD THE
            </h1>
            <h1 style={{ fontWeight: 500, marginTop: 0, marginBottom: 20 }}>
              KITCHEN OF YOUR DREAMS.
            </h1>
            <h2
              className="mobile-none"
              style={{ fontWeight: 300, marginTop: 0, marginBottom: 5 }}
            >
              Choose from thousands of <br /> finishes and styles!
            </h2>
            <Button className="btn" href="#contact">
              GET STARTED
            </Button>
          </HeaderContent>
        </div>
        <div>
          <img src={headerTwo} alt="Header Two" />
          <HeaderContent className="responsive-header">
            <h1 style={{ marginTop: 0, marginBottom: 0 }}>
              DESIGNED TO HELP BUILD,
            </h1>
            <h1 style={{ fontWeight: 500, marginTop: 0, marginBottom: 20 }}>
              ORDER, AND FULLY ASSEMBLE.
            </h1>
            <h2
              className="mobile-none"
              style={{ fontWeight: 300, marginTop: 0, marginBottom: 5 }}
            >
              We also offer free design services!
            </h2>
            <Button className="btn" href="#contact">
              GET STARTED
            </Button>
          </HeaderContent>
        </div>
        <div>
          <img src={headerThree} alt="Header Three" />
          <HeaderContent className="responsive-header">
            <h1 style={{ marginTop: 0, marginBottom: 0 }}>
              CUSTOMER SATISFACTION
            </h1>
            <h1 style={{ fontWeight: 500, marginTop: 0, marginBottom: 20 }}>
              GAURANTEED.
            </h1>
            <h2
              className="mobile-none"
              style={{ fontWeight: 300, marginTop: 0, marginBottom: 5 }}
            >
              Get your free quote today!
            </h2>
            <Button className="btn" href="#contact">
              GET STARTED
            </Button>
          </HeaderContent>
        </div>
      </Carousel>
    </>
  );
};

export default Header;
